var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector130(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89083 10.8843C2.16898 13.4965 0.496171 18.0498 0 19.9999C0.874206 18.9115 3.00538 16.4761 4.53642 15.4421C6.45022 14.1496 9.28548 15.238 13.1131 12.2448C16.1752 9.8503 16.7517 3.08389 16.6572 0C14.0582 0.0226756 7.95291 0.666664 4.32377 3.06121C0.694639 5.45576 0.637934 10.4535 1.06322 12.653C1.60665 11.882 3.20385 9.83669 5.24523 7.82309C7.28662 5.8095 10.6322 4.76188 12.0499 4.48978C10.7976 5.53285 7.61268 8.27207 4.89083 10.8843Z",
    fill: "#0EBE89"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector130);
export default __webpack_public_path__ + "static/media/vector 130.ac9db0bb501cabb9600a8e070d7756ad.svg";
export { ForwardRef as ReactComponent };